'use strict';

(function () {
	angular.module('onboarding.common.security')
		.directive('cobLogin', cobLogin);

	cobLogin.$inject = [
		'$rootScope', '$state', '$stateParams', 'subjectObserverMessagesService', 'observerService', '$log', 'authenticationService',
		'sessionService', '$window', 'validationService'
	];

	var $rootScope,
		$state,
		$stateParams,
		subjectObserverMessagesService,
		observerService,
		subjectMessages,
		observerMessages,
		$log,
		authenticationService,
		sessionService,
		$window,
		validationService;

	function cobLogin(_$rootScope_,
		_$state_,
		_$stateParams_,
		_subjectObserverMessagesService_,
		_observerService_,
		_$log_,
		_authenticationService_,
		_sessionService_,
		_window_,
		_validationService_) {

		subjectObserverMessagesService = _subjectObserverMessagesService_;
		observerService = _observerService_;
		$log = _$log_;
		$state = _$state_;
		$stateParams = _$stateParams_;
		authenticationService = _authenticationService_;
		sessionService = _sessionService_;
		$rootScope = _$rootScope_,
		$window = _window_;
		validationService = _validationService_;

		return {
			scope: {
				domain: '=',
				forgotUsernameCallback: '&',
				forgotPasswordCallback: '&'
			},
			templateUrl: '/app/common/security/login.html',
			replace: true,
			link: linkFunction
		};
	}

	function linkFunction(scope) {

		activate();

		///////////////////////////////

		function activate() {
			subjectMessages = subjectObserverMessagesService.getSubjectMessages();
			observerMessages = subjectObserverMessagesService.getObserverMessages();

			scope.m = {
				userName: '',
				password: '',
				sitecoreMessage: '',
				rememberMe: false,
				loginInProgress: false,
				year: new Date().getFullYear(),
				isBrokerLandingPage: false,
				usernameError: '',
				passwordError: '',
				errors: []
			};

			scope.dismissErrors = dismissErrors;
			scope.m.domain = sessionService.getDomain() !== null;
			scope.m.isBrokerLandingPage = sessionService.getDomain() === null ? false : true;

			registerObserverHandlers();
			fetchCredentials();
		}

		function registerObserverHandlers() {
			observerService.registerHandlers(scope,
				[
					{ message: observerMessages.COB_OBSERVER_LOGIN_FINISHED_SUCCESS, handler: onLoginSuccess },
					{ message: observerMessages.COB_OBSERVER_CHANGE_WELCOME_VIEW, handler: dismissErrors }
				]);
		}


		function onLoginSuccess() {
			if (scope.m.rememberMe) {
				localStorage.setItem('dob.credentials',
					angular.toJson({ userName: scope.m.userName.trim() }));
			} else {
				localStorage.removeItem('dob.credentials');
			}



			if (sessionService.isAuthorizedInternalAdmin()) {
				$state.go('carriersAdmin');
			} else if (authenticationService.isAuthorizedBrokerRead()) {
				if ($window.location.href.indexOf('/app') < 0) {
					$window.location.href = '/carriers';
				} else {
					$state.go('carriers');
				}
			} else if (sessionService.isAuthorizedCarrierRead()) {
				var broker = sessionService.getBrokerBranding();
				if (broker) {
					sessionService.saveCarrierVisit();
				}
				$rootScope.firstLogin = true;
				$state.go('carrierProfile.company');
			}
		}

		function dismissErrors() {
			scope.m.usernameError = '';
			scope.m.passwordError = '';
			scope.m.password = '';
			scope.m.errors = [];

			if (!scope.m.rememberMe) {
				scope.m.userName = ''; 
			}
		}

		function fetchCredentials() {
			if (localStorage.getItem('dob.credentials') !== null) {
				var credentials = angular.fromJson(localStorage.getItem('dob.credentials'));
				scope.m.rememberMe = true;
				scope.m.userName = credentials.userName;
				scope.m.password = credentials.password;
			}
		}
	}

})();
